import React, { useEffect } from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import ProtectedRoute from '../ProtectedRoute';
import { useRolesPermissions, MENU_PERMISSION_PREFIXES } from '../../contexts/RolesPermissionsContext';
import { ROUTE_CONSTANTS, STRING_CONSTANTS } from '../../constants/common';

import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Middleware: permission check for current path. Renders "Access Denied" within layout if no access.
 */
function PermissionMiddleware({ children }) {
  const location = useLocation();
  const pathname = location.pathname || '';
  const { loaded, showMenuForPath, fetchRolesMe } = useRolesPermissions();
  const { t } = useLanguage();

  useEffect(() => {
    if (!loaded) fetchRolesMe();
  }, [loaded, fetchRolesMe]);

  const pathKey = Object.keys(MENU_PERMISSION_PREFIXES || {}).find(
    (k) => pathname === k || pathname.startsWith(k + '/')
  );

  if (!pathKey) return children;

  if (!loaded) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontSize: '16px',
          color: '#666',
        }}
      >
        {STRING_CONSTANTS?.LABELS?.LOADING || 'Loading...'}
      </div>
    );
  }

  if (!showMenuForPath(pathKey)) {
    return <Navigate to={ROUTE_CONSTANTS.AUTH.DASHBOARD} replace state={{ from: location }} />;
    // return (
    //   <AdminLayout>
    //     <PageNotFound
    //       title={t('access_denied') || 'Access Denied'}
    //       message={t('access_denied_message') || 'You do not have permission to access this section.'}
    //     />
    //   </AdminLayout>
    // );
  }

  return children;
}

/**
 * Single middleware layout: auth (ProtectedRoute) + permission check, then children or <Outlet />.
 */
export default function ProtectedLayout({ children }) {
  return (
    <ProtectedRoute>
      <PermissionMiddleware>
        {children || <Outlet />}
      </PermissionMiddleware>
    </ProtectedRoute>
  );
}
